import React from "react";
import { Link } from "react-router-dom";

import { PartnerPageLayout } from "../../components/PartnerPageLayout/PartnerPageLayout";
import { xboxOnboardSiteLocationPrefix } from "../../constants";
import { getImage, ImageType } from "../../helpers/imageHelper";
import { useBlockAaaUser } from "../../helpers/useBlockAaaUser";
import { PartnerAccessLevel, usePartnerRouteGuard } from "../../helpers/usePartnerRouteGuard";
import { useStrings } from "../../localization/localizationHelpers";
import * as styles from "./ProgramsPage.module.css";

const ProgramsPage: React.FC = () => {
  const isPageReady = usePartnerRouteGuard(PartnerAccessLevel.EnrollmentFinished);
  const isAaaUser = useBlockAaaUser();
  const [
    programsLabel,
    programsPageTitle,
    programsSubtitle,
    pitchYourGameTitle,
    pitchYourGameDescription,
    startPitchButton,
  ] = useStrings(
    "programsLabel",
    "programsPageTitle",
    "programsSubtitle",
    "pitchYourGameTitle",
    "pitchYourGameDescription",
    "startPitchButton"
  );

  if (!isPageReady || isAaaUser) {
    return null;
  }

  return (
    <>
      <PartnerPageLayout breadcrumbLabel={programsLabel}>
        <h1 className={styles.pageTitle}>{programsPageTitle}</h1>
        <p className={styles.pageSubtitle}>{programsSubtitle}</p>

        <article className={styles.programCardPitch}>
          <img
            aria-hidden="true"
            alt=""
            className={styles.programCardImage}
            src={getImage("pitch_cover", ImageType.Jpg)}
          />
          <div className={styles.programCardContent}>
            <h2 className={styles.programCardTitle}>{pitchYourGameTitle}</h2>
            <p className={styles.programCardDescription}>{pitchYourGameDescription}</p>
            <div className={styles.programCardButtonRow}>
              <Link
                className={styles.programCardButtonPitch}
                to={`${xboxOnboardSiteLocationPrefix}/pitch`}
              >
                {startPitchButton}
              </Link>
            </div>
          </div>
        </article>
      </PartnerPageLayout>
    </>
  );
};

export default ProgramsPage;
